import {
  useEffect,
} from 'react'
import {
  useQuery,
} from '@tanstack/react-query'
import {
  referralService,
} from '../services/api'
import {
  trackOwnReferralCode,
} from '../analytics/posthog'

/**
 * Shared fetch for the current user's referral link, used by ReferralStrip and
 * ReferralLinkModal. React Query dedups the request across both via the shared
 * key, so a deep-linked arrival that opens the modal alongside the strip fetches
 * once.
 *
 * Side-effect: pins the user's own `referral_code` on their PostHog person so
 * referral attribution resolves natively (a referred user's `referred_by_code`
 * joins to this `referral_code`). Kept in the hook — not the API service — so the
 * service layer stays a pure data fetcher. The effect keys off the code string,
 * so refetches (e.g. window focus) that return the same code don't re-fire it.
 *
 * `enabled` gates the fetch (e.g. the modal only loads while open).
 */
export function useReferralLink({ enabled = true }: { enabled?: boolean } = {}) {
  const query = useQuery({
    queryKey: ['referral-link'],
    queryFn: () => referralService.getLink(),
    enabled,
  })

  const code = query.data?.referral_code
  useEffect(() => {
    if (code) {
      trackOwnReferralCode(code)
    }
  }, [code])

  return query
}
